import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useSelector } from 'react-redux'

import { useGetUserQuery, useUpdateUserActivationDataMutation } from 'common'
import { useToggleState } from 'hooks/useToggleState'
import { currentOrganizationSelector } from 'selectors/current_organization'

import { useUserDismissed } from './use-user-dismissed'

export const useToggleUserGuide = () => {
  const queryResult = useGetUserQuery()
  const closed = queryResult?.data?.activation_data?.user_guide_closed
  const [dismissed] = useUserDismissed()
  const { is_trial: isTrial } = useSelector(currentOrganizationSelector)
  const [update] = useUpdateUserActivationDataMutation()
  const isMobile = !useDeviceType('isDesktopUp')
  const [isMobileOpen, toggleMobileOpen] = useToggleState(false)

  const resolveToggle = () => {
    const closedUnset = (closed === undefined || closed === null)

    if (dismissed && closedUnset) return false
    if (!isTrial && closedUnset) return false

    return !closed
  }

  if (isMobile) {
    return [isMobileOpen, toggleMobileOpen]
  }

  return [resolveToggle(), () => update({ user_guide_closed: resolveToggle() })]
}
